<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="info" :show="message != null">{{message}}</b-alert>
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <div class="container-fluid">
        <div class="p-2 border-bottom border-info">
          <h4 class="text-info font-italic">
            <strong>ログインユーザ一覧</strong>
            <span class="ml-2"><button class="btn btn-info" @click="reloadItems"><i class="fas fa-sync"/> 再読込</button></span>
            <span class="ml-2"><button class="btn btn-warning" @click="showRegisterModal"><i class="fas fa-plus"/> 新規登録</button></span>
          </h4>
        </div>
        <div>
          <v-client-table :columns="columns" :data="users" :options="options" class="users-table">
            <a slot="Username" slot-scope="props">
              <b-btn variant="link" size="sm" @click="showDetailModal(props.row)"><b>{{props.row.Username}}</b></b-btn>
            </a>
            <a slot="Enabled" slot-scope="props">
              {{props.row.Enabled ? '有効' : '無効'}}
            </a>
            <a slot="email" slot-scope="props">
              {{props.row.Attributes.find(a => a.Name === 'email').Value}}
            </a>
            <a slot="sub" slot-scope="props">
              {{props.row.Attributes.find(a => a.Name === 'sub').Value}}
            </a>
            <a slot="UserStatus" slot-scope="props">
              <span v-if="props.row.UserStatus === 'UNCONFIRMED'">
                <b-btn variant="link" size="sm" @click="showModal(props.row)">{{props.row.UserStatus}}</b-btn>
              </span>
              <span v-else>
                {{props.row.UserStatus}}
              </span>
            </a>
          </v-client-table>
        </div>
        <div v-if="paginationToken"><b-btn @click="loadMore">もっと読み込む</b-btn></div>
      </div>
    </div>

    <bffooter></bffooter>

    <div>
     <b-modal ref="userDetailModal" centered title="ユーザ詳細"
        header-bg-variant="info"
        header-text-variant="light"
        hide-footer>
        <div>
          <p class="my-4">
            <span>{{currentUser}}</span>
          </p>
        </div>
     </b-modal>
     <b-modal ref="userRemoveModal" centered title="ユーザの削除"
        header-bg-variant="info"
        header-text-variant="light"
        hide-footer>
        <div>
          <p class="my-4">
            <span class="text-danger"><b>このユーザ{{currentUser.Username}}を削除しますか？ この操作は取り消せません</b></span>
          </p>
          <b-btn class="mt-3" variant="outline-danger" block @click="onRemoveUser">削除</b-btn>
        </div>
      </b-modal>
      <b-modal ref="registerModal" title="新規登録"
        header-bg-variant="info"
        header-text-variant="light"
        >
        <b-alert variant="danger" :show="registerError != null">{{registerError}}</b-alert>
        <form @submit.stop.prevent="onRegister">
          <b-form-group label="名前:">
            <b-form-input
                        id="username"
                        type="text"
                        size="10"
                        v-model="form.username"
                        :state="validators.username"
                        required
                        placeholder="必須">
            </b-form-input>
            <b-form-invalid-feedback id="usernameFeedback">
              入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="email">
            <b-form-input
                        id="email"
                        type="text"
                        size="13"
                        v-model="form.email"
                        :state="validators.email"
                        required
                        placeholder="必須">
            </b-form-input>
            <b-form-invalid-feedback id="emailFeedback">
              入力してください
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="パスワード:">
            <b-form-input
                        id="password"
                        type="text"
                        size="13"
                        v-model="form.password"
                        :state="validators.password"
                        required
                        placeholder="8文字以上。英数字大文字を一つ以上含む">
            </b-form-input>
            <b-form-invalid-feedback id="passwordFeedback">
              8文字以上(英数字大文字を一つ以上含む)を入力してください
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
        <div slot="modal-footer" class="w-100">
          <b-btn variant="primary" @click="onRegister">
           登録
          </b-btn>
          <b-btn variant="info" @click="show=false">
           閉じる
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Vue from 'vue'
import moment from 'moment-timezone'
import { ClientTable } from 'vue-tables-2'

import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'

const logger = new Logger('CognitoUsers')
Vue.use(ClientTable)

export default {
  name: 'CognitoUsers',
  components: {
    bfheader,
    bffooter
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      registerError: null,
      form: {
        username: null,
        email: null,
        password: null
      },
      validators: {
        username: null,
        email: null,
        password: null
      },
      users: [],
      columns: [
        'Username', 'email', 'UserStatus', 'Enabled', 'sub',
        'UserCreateDate', 'UserLastModifiedDate'
      ],
      options: {
        headings: {
          Username: 'uid',
          email: 'email',
          sub: 'CognitoIdentityId',
          Enabled: '有効',
          UserStatus: 'ステータス',
          UserCreateDate: '登録日時',
          UserLastModifiedDate: '更新日時'
        },
        sortable: [ 'Username' ],
        filterable: [ 'Username' ],
        texts: {
          filterPlaceholder: '検索する'
        },
        sortIcon: {
          base: 'fas', up: 'fa-arrow-up', down: 'fa-arrow-down', is: 'fa-sort'
        },
        orderBy: {
          column: 'Username',
          ascending: true
        },
        templates: {
          UserCreateDate: function (h, row) {
            return (!row.UserCreateDate) ? '' : moment(row.UserCreateDate, 'x').format('YYYY/MM/DD HH:mm')
          },
          UserLastModifiedDate: function (h, row) {
            return (!row.UserLastModifiedDate) ? '' : moment(row.UserLastModifiedDate, 'x').format('YYYY/MM/DD HH:mm')
          }
        }
      },
      currentUser: {},
      paginationToken: null
    }
  },
  mounted: function () {
    this.loadItems()
  },
  methods: {
    open (id) {
      logger.debug('open', id)
    },
    formatDate (time) {
      return moment(time).format('MM/DD HH:mm')
    },
    loadMore () {
      this.loadItems()
    },
    loadItems () {
      this.message = null
      this.error = null
      return new Promise((resolve) => {
        setTimeout(() => {
          return this.$store.dispatch('fetchCognitoUsers', { paginationToken: this.paginationToken }).then(data => {
            logger.debug('found users:', data)
            this.paginationToken = data.PaginationToken
            data.Users.forEach((user, index) => {
              this.users.push(user)
            })
          }).catch(err => {
            logger.error(err)
            this.error = err.message || err
          })
        }, 1000)
      })
    },
    reloadItems () {
      this.users = []
      this.paginationToken = null
      this.loadItems()
    },
    refreshItems () {
      this.reloadItems()
    },
    onRemoveUser () {
      this.message = null
      this.error = null
      let username = this.currentUser.Username
      this.$store.dispatch('deleteCognitoUser', { username }).then((data) => {
        logger.debug(data)
        this.message = '削除しました'
        this.$refs.userRemoveModal.hide()
        this.loadItems()
      }).catch(err => {
        logger.error(err)
        this.error = err.message || err
      })
    },
    showDetailModal (user) {
      this.currentUser = user
      this.$refs.userDetailModal.show()
    },
    showModal (user) {
      this.currentUser = user
      this.$refs.userRemoveModal.show()
    },
    validate () {
      this.validators.username = this.form.username && this.form.username.length >= 1
      this.validators.email = this.form.email && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.form.email)
      this.validators.password = this.form.password && this.form.password.length >= 8
      return ['username', 'email', 'password'].every(p => this.validators[p])
    },
    onRegister () {
      this.error = null
      this.message = null
      logger.debug(this.form)
      if (!this.validate()) {
        logger.debug(this.validators)
        return
      }
      this.form.email = this.form.email.toLowerCase()
      let newData = Object.assign({}, this.$data.form)
      this.loading = true
      return this.$store.dispatch('createCognitoUser', { newUser: newData }).then(() => {
        this.loading = false
        this.message = '登録しました'
        this.form = {
          username: null,
          email: null,
          password: null
        }
        this.validators = {
          username: null,
          email: null,
          password: null
        }
        this.$refs.registerModal.hide()
        this.refreshItems()
      }).catch(err => {
        this.loading = false
        logger.error(err)
        this.registerError = err.message || err
      })
    },
    showRegisterModal () {
      this.$refs.registerModal.show()
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
